<template>
  <div id="app">
    <ion-app>
      <side-menu />
      <ion-vue-router main :animated="true" id="main-content" />
      <ion-menu-controller></ion-menu-controller>
      <ion-modal-controller></ion-modal-controller>
      <ion-toast-controller></ion-toast-controller>
      <ion-alert-controller></ion-alert-controller>
      <ion-loading-controller></ion-loading-controller>
      <ion-actionsheet-controller></ion-actionsheet-controller>
    </ion-app>
  </div>
</template>

<style src='@ionic/core/css/core.css'></style>
<style src='@ionic/core/css/ionic.bundle.css'></style>

<script>
import SideMenu from "./views/SideMenu";
export default {
  name: "app",
  components: {
    SideMenu
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.modal-wrapper {
  height: 90% !important;
  min-height: 90% !important;
}
.fab {
  font-size: 30px;
  z-index: 1000;
}
.vue-map {
  border-radius: 6px !important;
}
ion-chip {
  border-radius: 8px;
}
ion-card {
  margin-bottom: 15px !important;
}
ion-card,
.searchbar-input {
  -webkit-box-shadow: 0 1px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12) !important;
  -moz-box-shadow: 0 1px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0 1px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12) !important;
}
ion-card-title {
  color: var(--ion-color-dark) !important;
}
ion-card-subtitle {
  color: var(--ion-color-medium) !important;
}
ion-list-header {
  text-transform: uppercase;
  background-color: #eeeeee;
}
img.login-google,
img.download-apple,
img.download-google {
  cursor: pointer;
  width: auto;
  height: 45px;
  margin-left: 10px;
  margin-right: 10px;
  display: inline-block;
  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.2));
  &:hover {
    -webkit-filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.2));
    filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.2));
  }
}
.alert-button-cancel {
  color: var(--ion-color-medium) !important;
}
.alert-button-primary {
  color: var(--ion-color-primary) !important;
}
.ion-color-navbar {
  --ion-color-base: #454d66;
  --ion-color-base-rgb: 69, 77, 102;
  --ion-color-contrast: #ffffff;
  --ion-color-contrast-rgb: 255, 255, 255;
  --ion-color-shade: #3d445a;
  --ion-color-tint: #585f75;
}
.ion-color-info {
  --ion-color-base: #1c819e;
  --ion-color-base-rgb: 28, 129, 158;
  --ion-color-contrast: #ffffff;
  --ion-color-contrast-rgb: 255, 255, 255;
  --ion-color-shade: #19728b;
  --ion-color-tint: #338ea8;
}
.ion-color-android {
  --ion-color-base: #a4c639;
  --ion-color-base-rgb: 164, 198, 57;
  --ion-color-contrast: #000000;
  --ion-color-contrast-rgb: 0, 0, 0;
  --ion-color-shade: #90ae32;
  --ion-color-tint: #adcc4d;
}
.ion-color-google {
  --ion-color-base: #4285f4;
  --ion-color-base-rgb: 66, 133, 244;
  --ion-color-contrast: #ffffff;
  --ion-color-contrast-rgb: 255, 255, 255;
  --ion-color-shade: #3a75d7;
  --ion-color-tint: #5591f5;
}
.ion-color-apple {
  --ion-color-base: #7d7d7d;
  --ion-color-base-rgb: 125, 125, 125;
  --ion-color-contrast: #ffffff;
  --ion-color-contrast-rgb: 255, 255, 255;
  --ion-color-shade: #6e6e6e;
  --ion-color-tint: #8a8a8a;
}
:root {
  --ion-background-color: #f6f6f6;
  --ion-toolbar-background: #eeeeee;
  --ion-tab-bar-background: #eeeeee;
  --ion-item-background: #ffffff;

  --ion-color-primary: #009975;
  --ion-color-primary-rgb: 0, 153, 117;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #008767;
  --ion-color-primary-tint: #1aa383;

  --ion-color-secondary: #58b368;
  --ion-color-secondary-rgb: 88, 179, 104;
  --ion-color-secondary-contrast: #000000;
  --ion-color-secondary-contrast-rgb: 0, 0, 0;
  --ion-color-secondary-shade: #4d9e5c;
  --ion-color-secondary-tint: #69bb77;

  --ion-color-tertiary: #e4c666;
  --ion-color-tertiary-rgb: 228, 198, 102;
  --ion-color-tertiary-contrast: #000000;
  --ion-color-tertiary-contrast-rgb: 0, 0, 0;
  --ion-color-tertiary-shade: #c9ae5a;
  --ion-color-tertiary-tint: #e7cc75;

  --ion-color-success: #008f00;
  --ion-color-success-rgb: 0, 143, 0;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #007e00;
  --ion-color-success-tint: #1a9a1a;

  --ion-color-warning: #ffb961;
  --ion-color-warning-rgb: 255, 185, 97;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb: 0, 0, 0;
  --ion-color-warning-shade: #e0a355;
  --ion-color-warning-tint: #ffc071;

  --ion-color-danger: #cd3f3e;
  --ion-color-danger-rgb: 205, 63, 62;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #b43737;
  --ion-color-danger-tint: #d25251;

  --ion-color-dark: #222428;
  --ion-color-dark-rgb: 34, 34, 34;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #1e2023;
  --ion-color-dark-tint: #383a3e;

  --ion-color-medium: #989aa2;
  --ion-color-medium-rgb: 152, 154, 162;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255, 255, 255;
  --ion-color-medium-shade: #86888f;
  --ion-color-medium-tint: #a2a4ab;

  --ion-color-light: #ffffff;
  --ion-color-light-rgb: 255, 255, 255;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #e0e0e0;
  --ion-color-light-tint: #ffffff;
}
</style>
